var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dash-page-new',{attrs:{"title":_vm.$t('mailer.automations.title'),"root":_vm.$t('Newsletter')}},[_c('ws-button',{attrs:{"label":"CampaignDetails","to":_vm.businessDashLink("fine_mailer/view/campaign-23423")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }